import { render } from "./ClinicUpdateOwnerOffcanvas.vue?vue&type=template&id=fc1f52d4&scoped=true"
import script from "./ClinicUpdateOwnerOffcanvas.vue?vue&type=script&lang=js"
export * from "./ClinicUpdateOwnerOffcanvas.vue?vue&type=script&lang=js"

import "./ClinicUpdateOwnerOffcanvas.vue?vue&type=style&index=0&id=fc1f52d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc1f52d4"]])

export default __exports__